export default __webpack_public_path__ + "static/media/ag_13.8f41f4aa.wav";